import { getProxiedServiceUrl, getProxiedUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { DocumentUploadService } from 'gw-portals-document-js';

export default class GatewayClaimService {
    static getClaimDetail(claimNumber, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
        //      'getClaimDetail', [claimNumber], additionalHeaders);
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getClaimDetail', [claimNumber], additionalHeaders);
    }

    static getRecentlyViewedClaims(additionalHeaders = {}) {
        alert('One');
        // return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
        //     'getRecentlyViewedClaims', [], additionalHeaders);
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getRecentlyViewedClaims', [], additionalHeaders);
    }

    static addRecentlyViewedClaim(claimNumber, additionalHeaders = {}) {
        alert('2');
        // return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
        //     'addRecentlyViewedClaim', [claimNumber], additionalHeaders);
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'addRecentlyViewedClaim', [claimNumber], additionalHeaders);
    }

    static getClaimsForCurrentUser(data, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
        //     'getClaimsForCurrentUser', data, additionalHeaders);
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getClaimsForCurrentUser', data, additionalHeaders);
    }

    static getOpenClaimsForCurrentUser(data, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
        //     'getOpenClaimsForCurrentUser', data, additionalHeaders);
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getOpenClaimsForCurrentUser', data, additionalHeaders);
    }

    static getClosedClaimsForCurrentUser(data, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
        //     'getClosedClaimsForCurrentUser', data, additionalHeaders);
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getClosedClaimsForCurrentUser', data, additionalHeaders);
    }

    static claimsDocUploadToken(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaimDocs'),
            'generateUploadToken',
            params, additionalHeaders);
    }

    static claimsRemoveDocument(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaimDocs'),
            'removeDocument',
            params, additionalHeaders);
    }

    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('uploadDocument'), file, documentMetadata, additionalHeaders);
    }

    static getClaimsFnolList(authHeader = {}) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
        };
        return fetch(getProxiedUrl('riclaims/claims'), params).then((response) => response.json())
            .then((response) => {
                return response;
            }).catch((err) => {
                return Promise.reject({
                    error: 'Error with service'
                });
            });
    }

    static getFnolDocument(serviceEndpoint, authHeader = {}) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json'
            },
        };
        return fetch(getProxiedUrl(serviceEndpoint), params).then((response) => response.blob()).catch((err) => {
            return Promise.reject({
                error: 'Error with service'
            });
        });
    }

    static getClaimsSavedList(authHeader = {}) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
        };
        return fetch(getProxiedUrl('riclaims/claims/saved'), params).then((response) => response.json())
            .then((response) => {
                return response;
            }).catch((err) => {
                return Promise.reject({
                    error: 'Error with service'
                });
            });
    }
    //FB 21577 -----------------
    static getDocTypes(authHeader = {}) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
        };
        return fetch(getProxiedUrl('ripolicy/files/list/claims/doctypes'), params).then((response) => response.json())
            .then((response) => {
                return response;
            }).catch((err) => {
                return Promise.reject({
                    error: 'Error with service'
                });
            });

    }    
    static getFileUploadHistory(policyNumber, authHeader = {}) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
        };
        return fetch(getProxiedUrl('ripolicy/files/list/policy/' + policyNumber), params).then((response) => response.json())
            .then((response) => {
                return response;
            }).catch((err) => {
                return Promise.reject({
                    error: 'Error with service'
                });
            });
    }
    static uploadFile(formData, authHeader = {}) {
        const params = {
            method: 'POST',
            headers: {
                Authorization: authHeader.Authorization,
            },
            body: formData
        };
        return fetch(getProxiedUrl('ripolicy/files/upload/db'), params)
        .then((resp) => {
            if (!resp.ok) {
                throw new Error(`${url} - ${resp.statusText}`);
            }
            return resp;
        })
        .catch((err) => {
                return Promise.reject({
                    error: 'Error with service'
                });
            });
    }
    static downloadFile(fileId, authHeader = {}) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
        };
        return fetch(getProxiedUrl('ripolicy/files/download/' + fileId), params).then((response) => response.json())
            .then((response) => {
                return response;
            }).catch((err) => {
                return Promise.reject({
                    error: 'Error with service'
                });
            });
        }
}
